module.exports = __webpack_public_path__ + "static/Corprate_Careers-Stores_03-55e6184237062c8b1be669a09ebe9188.jpg";